import GoogleAnalytics from "react-ga";

export function setupAnalytics(gaTrackingCode: string) {
    console.log(`siteCode: ${gaTrackingCode}`);
    GoogleAnalytics.initialize(gaTrackingCode);
}
